import { render, staticRenderFns } from "./TopImg.vue?vue&type=template&id=e99e8e88&scoped=true"
import script from "./TopImg.vue?vue&type=script&lang=js"
export * from "./TopImg.vue?vue&type=script&lang=js"
import style0 from "./TopImg.vue?vue&type=style&index=0&id=e99e8e88&prod&scoped=true&lang=less"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "e99e8e88",
  null
  
)

export default component.exports